import React, { useState, useEffect } from "react";

import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import ProgressBar from "react-bootstrap/ProgressBar";
import Row from "react-bootstrap/Row";

import CountUp from "react-countup";

function ReportCard({ stats = [] }) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(false);
    const timer = setTimeout(() => setAnimate(true), 200);
    return () => clearTimeout(timer);
  }, [stats]);

  return (
    <Row>
      {stats.map((item, i) => {
        const Icon = item.icon || null;

        return (
          <Col md={6} key={i} className="mb-3">
            <Card
              className="fancy-card p-4 shadow-sm border-0 position-relative overflow-hidden"
              data-type={item.title}
              style={{
                "--card-color": item.color || "#007bff",
              }}
            >
              <div className="overlay"></div>

              {/* SAFE ICON */}
              <div className="bg-icon">
                {Icon ? <Icon /> : null}
              </div>

              <div className="position-relative z-1">
                <h6 className="title-text text-muted">
                  {item.title}
                </h6>

                <h4 className="count-text fw-bold my-3">
                  {animate && (
                    <CountUp
                      start={0}
                      end={item.value || 0}
                      duration={1.5}
                    />
                  )}
                </h4>

                <ProgressBar
                  now={animate ? item.progress || 0 : 0}
                  style={{
                    height: "8px",
                    borderRadius: "10px",
                  }}
                />
              </div>
            </Card>
          </Col>
        );
      })}

      <style>{`
        .fancy-card {
          border-radius: 12px;
          background: #fff;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .fancy-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 15px 30px rgba(0,0,0,0.15);
        }

        .overlay {
          position: absolute;
          inset: 0;
          opacity: 0;
          transition: 0.4s ease;
        }

        .fancy-card[data-type] .overlay {
          background: var(--card-color);
        }

        .fancy-card:hover .overlay {
          opacity: 0.85;
        }

        .bg-icon {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 60px;
          opacity: 0.12;
          transition: 0.4s ease;
          color: var(--card-color);
        }

        .fancy-card:hover .bg-icon {
          opacity: 0.3;
          color: #fff;
        }

        .title-text,
        .count-text {
          position: relative;
          z-index: 2;
        }

        .fancy-card:hover .title-text,
        .fancy-card:hover .count-text {
          color: #fff !important;
        }

        .progress-bar {
          transition: width 1.5s ease-in-out !important;
        }
      `}</style>
    </Row>
  );
}

export default ReportCard;